import React from 'react'
import {
  Card,
  CardBody,
  Container
} from "shards-react";

import TopicGraph from './TopicGraph';
// import TopicGraphTrend from './TopicGraphTrend';


import InnerBox from './InnerBox'
import InnerBoxNetwork from './InnerBoxNetwork'


const TopicCard = props => {
  return (
    <Container style={{ maxWidth: '100%' }}>
      <Card className="text-white bg-secondary">
      
        <CardBody >   
          
        <h5 class="card-title  text-white mb-0">{props.data.title}</h5>

          <h6 class="card-subtitle mb-2 text-muted mt-1">
          
            <td className="float-left text-white"> Topic {props.data.topic_number}, Total Tweets: {props.data.tweets_count}, Tracking starting on {props.data.add_date}. (drag to zoom and pan)</td>
            
          </h6>
          
          <div className="mt-5 mb-2">
            <TopicGraph topicId={props.data.topicid} />
          </div>


          <div className="mt-2 mb-0">
              <InnerBox topicId={props.data.topicid} ></InnerBox>
              <InnerBoxNetwork topicId={props.data.topicid}></InnerBoxNetwork>          
          </div>

          </CardBody>

        
      </Card>
      

    </Container>
    
  )
}


export default TopicCard
